import { cn } from "utils/commonUtils";

// components/ui/modal/ModalContent.js
export default function ModalContent({ className = "", children }) {
    return (
        <div
            // className={`modal-content tw-relative tw-min-h-[100vh] sm:tw-min-h-fit sm:tw-h-auto tw-rounded-none sm:tw-rounded-[20px] ${className}`}
            className={` modal-content ${cn(
                " tw-relative tw-min-h-[100vh] sm:tw-min-h-fit sm:tw-h-auto tw-rounded-none sm:tw-rounded-[20px]",
                className
            )} `}
        >
            {children}
        </div>
    );
}